import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Card } from '..';
import './style.css';

export default function Table({
  items = [],
  columns = [],
  totalItems = 0,
  page,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
  emptyMessage = 'Nenhum registro encontrado.',
  getRowKey,
  pageSizeOptions = [5, 10, 20, 50, 100, 200, 500],
  onRowDoubleClick,
}) {
  const templateColumns = React.useMemo(
    () =>
      columns.length > 0
        ? columns.map(column => column.width || '1fr').join(' ')
        : undefined,
    [columns]
  );

  function handlePrevious() {
    if (page > 1 && onPageChange) {
      onPageChange(page - 1);
    }
  }

  function handleNext() {
    if (page < totalPages && onPageChange) {
      onPageChange(page + 1);
    }
  }

  return (
    <Card className="manager-table-card">
      <div className="manager-table-wrapper">
        <div className="manager-table">
          {columns.length > 0 && (
            <div
              className="manager-table-header"
              style={
                templateColumns
                  ? { '--table-columns': templateColumns }
                  : undefined
              }
            >
              {columns.map(column => (
                <div
                  key={column.id || column.key || String(column.header)}
                  className={column.headerClassName}
                >
                  {typeof column.header === 'function'
                    ? column.header()
                    : column.header}
                </div>
              ))}
            </div>
          )}

          {items.map(item => {
            const key =
              (getRowKey && getRowKey(item)) ||
              item.id ||
              item.key;
            
            // Identify columns for mobile view
            const primaryColumn = columns[0];
            const actionColumn = columns.find(c => 
              (c.cellClassName && c.cellClassName.includes('manager-table-col-actions')) || 
              c.key === 'actions' || 
              c.id === 'actions'
            );
            const otherColumns = columns.filter(c => c !== primaryColumn && c !== actionColumn);

            return (
              <React.Fragment key={key}>
                {/* Desktop Row */}
                <div
                  className="manager-table-row"
                  style={
                    templateColumns
                      ? { '--table-columns': templateColumns }
                      : undefined
                  }
                  onDoubleClick={onRowDoubleClick ? () => onRowDoubleClick(item) : undefined}
                >
                  {columns.map(column => (
                    <div
                      key={column.id || column.key || String(column.header)}
                      className={column.cellClassName || 'manager-table-cell'}
                      data-label={typeof column.header === 'string' ? column.header : ''}
                    >
                      {column.render(item)}
                    </div>
                  ))}
                </div>

                {/* Mobile Card Component */}
                <div 
                  className="manager-mobile-card"
                  onClick={() => onRowDoubleClick && onRowDoubleClick(item)} // Mobile often prefers single click, but respecting logic
                >
                   <div className="manager-mobile-card-header">
                      <div className="manager-mobile-card-primary">
                        {primaryColumn && primaryColumn.render(item)}
                      </div>
                      {actionColumn && (
                        <div className="manager-mobile-card-actions" onClick={e => e.stopPropagation()}>
                          {actionColumn.render(item)}
                        </div>
                      )}
                   </div>
                   
                   <div className="manager-mobile-card-body">
                      {otherColumns.map(column => (
                        <div 
                          key={column.id || column.key || String(column.header)} 
                          className="manager-mobile-card-item"
                        >
                          <span className="manager-mobile-card-label">
                            {typeof column.header === 'string' ? column.header : ''}
                          </span>
                          <div className="manager-mobile-card-value">
                            {column.render(item)}
                          </div>
                        </div>
                      ))}
                   </div>
                </div>
              </React.Fragment>
            );
          })}

          {totalItems === 0 && (
            <div className="manager-table-empty">
              {emptyMessage}
            </div>
          )}
        </div>
      </div>

      {totalItems > 0 && items.length > 0 && (
        <div className="manager-pagination">
          <div className="manager-pagination-info">
            <span>
              Mostrando{' '}
              <strong>{items.length}</strong>{' '}
              de{' '}
              <strong>{totalItems}</strong>{' '}
              itens
            </span>
          </div>
          <div className="manager-pagination-controls">
            <div className="manager-page-size">
              <label>
                Por página
                <select
                  value={pageSize}
                  onChange={event =>
                    onPageSizeChange &&
                    onPageSizeChange(Number(event.target.value))
                  }
                >
                  {pageSizeOptions.map(size => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
              </label>
            </div>
            <div className="manager-page-buttons">
              <button
                type="button"
                className="manager-page-button"
                onClick={handlePrevious}
                disabled={page <= 1}
              >
                <FiChevronLeft size={14} />
                <span>Anterior</span>
              </button>
              <span className="manager-page-indicator">
                Página {page} de {totalPages}
              </span>
              <button
                type="button"
                className="manager-page-button"
                onClick={handleNext}
                disabled={page >= totalPages}
              >
                <span>Próxima</span>
                <FiChevronRight size={14} />
              </button>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}


